import clsx from 'clsx'
import React from 'react'
import { Button as AriaButton } from 'react-aria-components'

import type { IProps } from './interfaces'
import styles from './styles.module.scss'

const Spinner = (): React.JSX.Element => (
  <svg className={styles.spinner} viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <circle className={styles.spinnerTrack} cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
    <path
      className={styles.spinnerArc}
      fill="currentColor"
      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
    />
  </svg>
)

export const Button = ({
  variant = 'primary',
  size = 'md',
  isLoading = false,
  loadingLabel,
  className,
  children,
  isDisabled,
  ...rest
}: IProps): React.JSX.Element => {
  return (
    <AriaButton
      className={clsx(styles.button, styles[variant], styles[size], isLoading && styles.loading, className)}
      // `undefined` (not `false`) when enabled, so a slot (a NumberField's − / +) can still disable it
      isDisabled={isDisabled || isLoading || undefined}
      {...rest}
    >
      {isLoading ? (
        <>
          <Spinner />
          {loadingLabel ?? children}
        </>
      ) : (
        children
      )}
    </AriaButton>
  )
}

export type { TButtonVariant, TButtonSize, IProps as ButtonProps } from './interfaces'
